import { useMemo } from 'react'

export const useGetProviderKeywords = ({
  providerBioKeywords,
  providerAdjectives,
  showProviderAdjectives,
}: {
  providerBioKeywords?: string[]
  providerAdjectives?: string[]
  showProviderAdjectives?: boolean
}) => {
  return useMemo(() => {
    if (showProviderAdjectives && providerAdjectives && providerAdjectives.length > 0) {
      return providerAdjectives
    }
    return providerBioKeywords
  }, [providerBioKeywords, providerAdjectives, showProviderAdjectives])
}
